
import { Link } from 'react-router-dom';
import { services } from '../../../mocks/services';

const ServicesGrid = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Our Services
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Professional bakkie removals and landscaping services across KwaZulu-Natal with transparent pricing and reliable service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl text-charcoal mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <Link
                  to={service.link}
                  className="text-primary font-semibold hover:text-primary-dark transition-colors inline-flex items-center cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
